import { defineComponent as _defineComponent } from 'vue'
import { CalendarEvent } from "@/ts/stores/event";
import { dateString } from "@/ts/utils/event-utils";

interface Props {
    event: CalendarEvent;
    appName?: string;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    event: { type: null, required: true },
    appName: { type: String, required: false }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
    event: CalendarEvent;
    appName?: string;
}



const baseUrl = props.appName === "PLUG-IN" ? "https://hajee.be/event" : "/event";

const __returned__ = { props, baseUrl, dateString }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})